export const GAMES = {
  NAME: 'game',
  NAMESPACE: (name) => `game/${name}`,
  CLEAR: 'CLEAR',
  SET_GAME: 'SET_GAME',
  GET_GAME: 'GET_GAME',

  GET_GAME_ID: 'GET_GAME_ID',
  GET_GAME_TARGET: 'GET_GAME_TARGET',
  GET_GAME_HINTS: 'GET_GAME_HINTS',
  GET_GAME_DATA: 'GET_GAME_DATA',
  GET_GAME_SELECT: 'GET_GAME_SELECT',
  GET_GAME_SCENES: 'GET_GAME_SCENES',
  GET_GAME_EXTEND: 'GET_GAME_EXTEND',
  GET_GAME_MODES: 'GET_GAME_MODES',
}

export const state = {
  id: null,
  target: null,
  hints: [],
  data: {},
  select: [],
  scenes: [],
  extend: [],
  modes: null,
  setting: {},
}

export const mutations = {
  [GAMES.CLEAR](state) {
    state.id = null
    state.target = null
    state.hints = []
    state.data = {}
    state.select = []
    state.scenes = []
    state.extend = []
    state.modes = null
    state.setting = {}
  },
  [GAMES.SET_GAME](state, { id, target, hints, data, select, scenes, extend, modes }) {
    state.id = id
    state.target = target
    state.hints = hints
    state.data = data
    state.select = select
    state.scenes = scenes
    state.extend = extend
    state.modes = modes
  },
}

export const getters = {
  [GAMES.GET_GAME](state) {
    return state
  },
  [GAMES.GET_GAME_ID](state) {
    return state.id
  },
  [GAMES.GET_GAME_TARGET](state) {
    return state.target
  },
  [GAMES.GET_GAME_HINTS](state) {
    return state.hints
  },
  [GAMES.GET_GAME_DATA](state) {
    return state.data
  },
  [GAMES.GET_GAME_SELECT](state) {
    return state.select
  },
  [GAMES.GET_GAME_SCENES](state) {
    return state.scenes
  },
  [GAMES.GET_GAME_EXTEND](state) {
    return state.extend
  },
  [GAMES.GET_GAME_MODES](state) {
    return state.modes
  },
}

export const actions = {
  [GAMES.CLEAR]({ commit }) {
    commit(GAMES.CLEAR)
  },
}
